require('./bitbucketFangornConfig.js');



//////////////////
// WEBPACK FOOTER
// ./addons/bitbucket/static/files.js
// module id = 786
// module chunks = 62